<!-- 企业级-业务领域-仓储业务-仓库管理 -->
<template>
  <div class="mainArea CWarehouseManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="leftTree">
          <el-tree
            class="defineTree"
            v-loading="sceneData.loading"
            :data="sceneData.list"
            node-key="TreeId"
            default-expand-all
            :expand-on-click-node="false"
            :props="defaultProps"
            @node-click="sceneNodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <!-- 自定义icon -->
              <i
                class="defineIcon"
                :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
              </i>
              <span :class="['label',{'selected': data.TreeId === sceneData.TreeId}]">{{ node.label }}</span>
              <!-- 添加、修改、删除 -->
              <span class="operate">
                <!-- <span class="el-icon-circle-plus-outline" @click="openDio('add',data.Level)"></span>
                <span class="el-icon-edit-outline" v-if="data.Level !='-1'" @click="openDio('edit',data.Level,data)"></span>
                <span class="el-icon-remove-outline" v-if="data.Level !='-1'" @click="openDio('del',data.Level,data)"></span> -->
                <!-- <span class="text" @click="updateSpace('updateSpace', data, node.id)" v-show="node.level != '-1'">修改</span>
                <span class="text" @click="operateDialogInfo('deleteSpace', data, node.id)">删除</span> -->
                <!-- <span class="text">修改</span>
                <span class="text">删除</span> -->
              </span>
            </span>
          </el-tree>
        </div>
        <div class="rightDiv">
          <!-- 添加客户信息 -->
          <div class="addButton">
            <el-button type="primary" @click="openDio('add',sceneData.Level)">添加</el-button>
          </div>

          <el-table v-loading="loading" :data="wareData" style="width: 100%" v-if="sceneData.Level == '-1'">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column label="仓库名称" prop="WareName"></el-table-column>
            <el-table-column label="仓库地址" prop="WareAddress"></el-table-column>
            <el-table-column label="库位（个）">
              <template slot-scope="scope">
                <el-button type="text" @click="sceneNodeClick(scope.row)">{{scope.row.StoreHouse}}个</el-button>
              </template>
            </el-table-column>
            <el-table-column label="库存">
              <template slot-scope="scope">
                <el-button type="text" @click="toRecord(scope.row.Id)">查询</el-button>
              </template>
            </el-table-column>
            <el-table-column label="设备">
              <template slot-scope="scope">
                <el-button type="text" @click="getDeviceBind(scope.row.Id)">{{scope.row.DevicesNo}}个</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="openDio('edit','-1',scope.row)">修改</el-button>
                <el-button type="text" @click="delectWare(scope.row.Id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-loading="loading" :data="wareData" style="width: 100%" v-if="sceneData.Level == '0'">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column label="库区名称" prop="StoreName"></el-table-column>
            <el-table-column label="所属仓库" prop="WareName"></el-table-column>
            <el-table-column label="货架（个）">
              <template slot-scope="scope">
                <el-button type="text" @click="sceneNodeClick(scope.row)">{{scope.row.Shelves}}个</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="openDio('edit','0',scope.row)">修改</el-button>
                <el-button type="text" @click="delectStore(scope.row.Id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-loading="loading" :data="wareData" style="width: 100%" v-if="sceneData.Level == '1'">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column label="货架ID(设备ID)" prop="DeviceId"></el-table-column>
            <el-table-column label="货架名称" prop="Name"></el-table-column>
            <el-table-column label="货架类型">
              <template slot-scope="scope">{{scope.row.Type}}</template>
            </el-table-column>
            <el-table-column label="货架条码">
              <template slot-scope="scope">
                <el-button type="text">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="货架二维码">
              <template slot-scope="scope">
                <el-button type="text">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="货位（个）">
              <template slot-scope="scope">
                <el-button type="text">{{scope.row.CargoLocation}}个</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="delectShelves(scope.row.Id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging" v-if="total>limits">
            <el-pagination
              @current-change="CurrentChange"
              :current-page.sync="curr"
              :page-size="limits"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="wareDio" :width="dioWidth" class="configDio wareDio" center @close="closeDio">
        <div class="contDio">
          <template v-if="sceneData.Level == '-1'">
            <el-form ref="form" :rules="rules" :model="dioform" label-width="90px">
              <el-form-item label="仓库名称:" prop="wareName">
                <el-input v-model="dioform.wareName"></el-input>
              </el-form-item>
              <el-form-item label="仓库地址:" prop="wareAddress">
                <el-input v-model="dioform.wareAddress"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitWare('form','-1')">确认</el-button>
                <el-button @click="wareDio = false">取消</el-button>
              </el-form-item>
            </el-form>
          </template>
          <template v-else-if="sceneData.Level == '0'">
            <el-form ref="form" label-width="90px" :model="dioform" :rules="rules">
              <el-form-item label="库区名称:" prop="StoreName">
                <el-input v-model="dioform.StoreName"></el-input>
              </el-form-item>
            </el-form>
            <div class="tit flex">
              <div>仓管员:</div>
              <div class="col6">已勾选：{{dioform.userInfo.length}}人</div>
            </div>
            <!--调用用户选择组件-->
            <authUserComp @CheckUserInfo="CheckUserInfo" v-if="wareDio" :userInfo="dioform.userInfo"></authUserComp>
          </template>
          <template v-else>
            <el-form ref="form" :rules="rules" label-width="90px" :model="dioform">
              <el-form-item label="货架:" prop="ShelveName">
                <el-input v-model="dioform.ShelveName" placeholder="请输入货架名称"></el-input>
              </el-form-item>
              <el-form-item label="设备ID:" prop="DeviceId">
                <el-input v-model="dioform.DeviceId" placeholder="请输入设备ID"></el-input>
              </el-form-item>
            </el-form>
            <!-- <el-form ref="form" label-width="90px" :model="dioform">
              <el-form-item label="货架:">
                <el-input v-model="dioform.ShelveName" placeholder="双击选择设备或输入虚拟货架名称" style="width:70%" @dblclick.native="openDeviceDio"></el-input>
                <el-button type="primary" @click="addDevice()">添加</el-button>
              </el-form-item>
              <el-form-item label="已选择:">
                <el-table :data="dioform.checkList" style="width: 100%">
                  <el-table-column type="index" label="序号" width="80px"></el-table-column>
                  <el-table-column label="货架ID">
                    <template slot-scope="scope">
                      <span v-if="scope.row.Id == ''">/</span>
                      <span v-else>{{scope.row.Id}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="货架名称" prop="Name"></el-table-column>
                  <el-table-column label="货架类型" prop="Type"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" @click="delDevice(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-form> -->
          </template>
        </div>
        <span slot="footer">
          <template v-if="sceneData.Level == '0'">
            <el-button @click="closeDio">取消</el-button>
            <el-button type="primary" @click="submitWare('form','0')">确定</el-button>
          </template>
          <template v-else-if="sceneData.Level == '1'">
            <el-button @click="closeDio">取消</el-button>
            <el-button type="primary" @click="submitWare('form','1')">确定</el-button>
          </template>
        </span>
      </el-dialog>
      <el-dialog title="选择设备" width="800px" :visible.sync="deviceDio" class="configDio">
        <div class="contDio">
          <el-form :inline="true">
            <el-form-item>
              <el-input v-model="deviceform.deviceId" placeholder="设备ID" clearable @keyup.enter.native="ShelvesDevicesList()"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="deviceform.deviceName" placeholder="设备名称" clearable @keyup.enter.native="ShelvesDevicesList()"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="deviceform.deviceType" placeholder="设备类型" @change="ShelvesDevicesList()">
                <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in deviceform.typeList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="ShelvesDevicesList()">搜索</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="deviceform.deviceList" style="width:100%" @selection-change="deviceSelectionChange">
            <el-table-column type="selection"></el-table-column>
            <el-table-column label="设备ID" prop="Id"></el-table-column>
            <el-table-column label="设备名称" prop="Name"></el-table-column>
            <el-table-column label="设备类型" prop="Type"></el-table-column>
          </el-table>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="submitDevice()">确认</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { expSceneApi } from "../../../../../static/js/exp/scene.js"
  import { bussinessApi,userApi,authApi } from '../../../../../static/js/api'
  import authUserComp from '../../../../assets/authUser'
  var vm
  export default {
    name: 'CWarehouseManage',
    components: {
      CBreadCrumb,
      authUserComp
    },
    data() {
      return {
        // 空间列表数据
        sceneData: {
          list: [],
          loading: false,
          selected: '-1',
          TreeId:'-1_-1',
          Level:'-1',
        },
        // 树形控件配置
        defaultProps: {
          children: 'Children',
          label: 'Name'
        },

        loading:false,
        wareData:[],//仓库数据||库区数据||货架数据

        //分页
        curr:1,
        limits:10,
        total:0,

        wareDio:false,//弹窗
        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗的宽度
        dioType:'',//弹窗的类型
        dioform:{
          Id:'',//仓库ID
          wareName:'',//仓库名称
          wareAddress:'',//仓库名称
          Level:'0',//树形的当前选中层级
          StoreName:'',//库区名称
          ShelveName:'',//货架名称
          DeviceId:'',//设备ID
          checkList:[],//已选择的设备
          userInfo:[],
        },
        rules:{
          wareName:[
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
          ],
          wareAddress:[
            { required: true, message: '请输入仓库地址', trigger: 'blur' },
          ],
          StoreName:[
            { required: true, message: '请输入库区名称', trigger: 'blur' },
          ],
          ShelveName:[
            { required: true, message: '请输入货架名称', trigger: 'blur' },
          ],
          DeviceId:[
            { required: true, message: '请输入设备ID', trigger: 'blur' },
          ]
        },

        deviceDio:false,//设备弹窗
        deviceform:{
          deviceId:'',
          deviceName:'',
          deviceType:'',
          typeList:[],
          deviceList:[],
          checkDevice:[],
        },

      };
    },
    mounted(){
      
    },
    async created() {
      vm = this
      this.WarehouseTree()
      this.WareList()
    },
    methods: {
      //获取授权的勾选用户
      CheckUserInfo(data){
        vm.dioform.userInfo = data
      },
      //添加虚拟货架
      addDevice(){
        if(vm.dioform.ShelveName == ''){
          showToast('请输入虚拟货架名称')
          return
        }
        let _Obj = {
          Id:'',
          Name:vm.dioform.ShelveName,
          Type:'虚拟货架'
        }
        vm.dioform.checkList.push(_Obj)
      },
      //删除已选择的设备
      delDevice(index){
        vm.dioform.checkList.splice(index,1)
      },
      //确定选中设备
      submitDevice(){
        vm.deviceDio = false
        vm.dioform.checkList = [...vm.dioform.checkList.concat(vm.deviceform.checkDevice)];//数组合并再去重
      },
      //双击打开设备弹窗
      openDeviceDio(){
        vm.ShelvesDevicesList()
        vm.deviceDio = true
      },
      //获取设备列表
      async ShelvesDevicesList(){
        let data = {
          'DeviceId': vm.deviceform.deviceId,
          'DeviceName': vm.deviceform.DeviceName,
          'DeviceType': vm.deviceform.DeviceType,
          'Curr':1,
          'Limits':99999,
        }
        const res = await bussinessApi.ShelvesDevicesList(data)
        if(res.ErrCode == 0){
          vm.deviceform.deviceList = res.Result.list
        }
      },
      //设备选中
      deviceSelectionChange(val){
        this.deviceform.checkDevice = val
        // var arr = []
        // for(var i in val){
        //   arr.push(val[i].Id)
        // }
        // this.deviceform.checkDevice = arr
      },
      //打开弹窗
      openDio(type,Level,info){
        vm.dioType = type
        if(Level == '-1'){
          vm.dioWidth = '500px'
          if(type == 'add'){
            vm.dioTitle = '添加仓库'
          }else if(type == 'edit'){
            vm.dioform.Id = info.Id
            vm.dioform.wareName = info.WareName
            vm.dioform.wareAddress = info.WareAddress
            vm.dioTitle = '修改仓库'
          }
        }else if(Level == '0'){
          vm.dioWidth = '800px'
          if(type == 'add'){
            vm.dioTitle = '添加库区'
          }else if(type == 'edit'){
            vm.dioform.Id = info.Id
            vm.dioform.StoreName = info.StoreName
            vm.dioform.userInfo = info.UserId
            // vm.dioform = info
            vm.dioTitle = '修改库区'
          }
        }else if(Level == '1'){
          vm.dioWidth = '700px'
          if(type == 'add'){
            vm.dioTitle = '添加货架'
          }else if(type == 'edit'){
            // vm.dioform = info
            vm.dioTitle = '修改货架'
          }
        }
        vm.wareDio = true
      },
      //关闭弹窗
      closeDio(){
        vm.dioform={
          Id:'',//仓库ID
          wareName:'',//仓库名称
          wareAddress:'',//仓库名称
          Level:'0',//树形的当前选中层级
          StoreName:'',//库区名称
          ShelveName:'',//货架名称
          DeviceId:'',//设备ID
          checkList:[],//已选择的设备
          userInfo:[],
        }
        vm.wareDio = false;
      },
      //跳转到库存
      toRecord(Id){
        this.$router.push({
          path:'/CInventoryRecord',
          query:{
            Id: Id
          }
        })
      },
      //跳转到设备绑定
      getDeviceBind(Id){
        var navBarActive = [{function_tab: 'CDeviceBind', function_name: '设备绑定'}]
        // 更新面包屑内容
        updataBreadCrumb(4, navBarActive)
        this.$router.push({
          path:'/CDeviceBind',
          query:{
            Id:Id
          }
        })
      },
      //递归方法(返回树形数据前两级)
      foreachFun(data){
        for(var i in data){
          data[i].TreeId = data[i].Level + '_' + data[i].Id
          if(data[i].Level == 1){
            delete data[i].Children
          }else{
            vm.foreachFun(data[i].Children)
          }
        }
        return data
      },
      // 获取位置列表
      async WarehouseTree() {
        let res = await bussinessApi.WarehouseTree()
        if(res.ErrCode == 0){
          const data = vm.foreachFun(res.Result.Data)
          const arr = [{
            'Level':'-1',
            'Id':-1,
            'TreeId':'-1_-1',
            'Name':'全部',
            'Children':data
          }]
          vm.sceneData.list = arr
          // vm.WareList()
        }
      },
      // 位置树形列表节点
      sceneNodeClick(data) {
        this.sceneData.TreeId = data.TreeId
        this.sceneData.selected = data.Id
        this.sceneData.Level = data.Level
        this.curr = 1
        this.wareData = []
        if(data.Level == '-1'){
          this.WareList()
        }else if(data.Level == '0'){
          this.StoreHouseList()
        }else{
          this.ShelvesList()
        }
        
      },
      // 获取仓库列表
      async WareList(curr,limits) {
        let data = {
          'LocationId': vm.sceneData.selected=='-1'? 0 : vm.sceneData.selected,
          'curr': curr ? curr : vm.curr,
          'Limits': limits ? limits : vm.limits
        }
        vm.loading = true
        let res = await bussinessApi.WareList(data)
        vm.loading = false
        if(res.ErrCode == 0){
          if(res.Result){
            for(var i in res.Result.List){
              res.Result.List[i].Level = '0'
              res.Result.List[i].TreeId = '0_'+res.Result.List[i].Id
            }
            vm.wareData = res.Result.List
            vm.curr = parseInt(res.Result.Curr)
            vm.total = parseInt(res.Result.Total)
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      // 获取库区列表
      async StoreHouseList(curr,limits) {
        let data = {
          'LocationId': vm.sceneData.selected,
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits : vm.limits
        }
        vm.loading = true
        let res = await bussinessApi.StoreHouseList(data)
        vm.loading = false
        if(res.ErrCode == 0){
          if(res.Result){
            for(var i in res.Result.List){
              res.Result.List[i].Level = '1'
              res.Result.List[i].TreeId = '1_'+res.Result.List[i].Id
            }
            vm.wareData = res.Result.List
            vm.curr = parseInt(res.Result.Curr)
            vm.total = parseInt(res.Result.Total)
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      // 获取货架列表
      async ShelvesList(curr,limits) {
        let data = {
          'LocationId': vm.sceneData.selected,
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits : vm.limits
        }
        vm.loading = true
        let res = await bussinessApi.ShelvesList(data)
        vm.loading = false
        if(res.ErrCode == 0){
          if(res.Result){
            vm.wareData = res.Result.List
            vm.curr = parseInt(res.Result.Curr)
            vm.total = parseInt(res.Result.Total)
          }
        }else{
          showToast(res.ErrMsg)
        }
      },

      //弹窗确认
      submitWare(formName,Level){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(Level == '-1'){
              vm.UpdateWare(vm.dioType=='add'? '1':'2')
            }else if(Level == '0'){
              vm.UpdateStore(vm.dioType=='add'? '1':'2')
            }else if(Level == '1'){
              vm.UpdateShelves(vm.dioType=='add'? '1':'2')
            }
          } else {
            return false;
          }
        });
      },
      //删除仓库
      delectWare(Id){
        vm.$confirm('是否删除该仓库', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vm.dioform.Id = Id
          vm.UpdateWare('3')
        }).catch(() => {});
      },
      //添加、修改、删除仓库
      async UpdateWare(type){
        var data = {
          'Edit':type
        }
        if(type != '3'){
          data.WareName = vm.dioform.wareName
          data.WareAddress = vm.dioform.wareAddress
        }
        if(type != '1'){
          data.WareId = vm.dioform.Id
        }
        const res = await bussinessApi.UpdateWare(data)
        if(res.ErrCode == 0){
          showToast('更新成功！')
          vm.wareDio = false;//关闭弹窗
          vm.dioform.Id =''
          vm.dioform.wareName=''
          vm.dioform.wareAddress=''
          vm.WarehouseTree();//更新树形列表
          vm.WareList(1);//更新仓库列表
        }else{
          showToast(res.ErrMsg)
        }
      },
      //删除库区
      delectStore(Id){
        vm.$confirm('是否删除该库区', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vm.dioform.Id = Id
          vm.UpdateStore('3')
        }).catch(() => {});
      },
      //添加、修改、删除库区
      async UpdateStore(type){
        var data = {
          'Edit':type,
          'LocationId': vm.sceneData.selected,
        }
        if(type != '3'){
          data.StoreName = vm.dioform.StoreName
          data.UserId = vm.dioform.userInfo
        }
        if(type != '1'){
          data.StoreId = vm.dioform.Id
        }
        const res = await bussinessApi.UpdateStore(data)
        if(res.ErrCode == 0){
          showToast('更新成功！')
          vm.wareDio = false;//关闭弹窗
          vm.dioform.Id = ''
          vm.dioform.StoreName = ''
          vm.dioform.userInfo = []
          vm.WarehouseTree();//更新树形结构
          vm.StoreHouseList(1);//更新库区列表
        }else{
          showToast(res.ErrMsg)
        }
      },

      //删除货架
      delectShelves(Id){
        vm.$confirm('是否删除该货架', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vm.dioform.Id = Id
          vm.UpdateShelves('3')
        }).catch(() => {});
      },
      //添加、修改、删除货架
      async UpdateShelves(type){
        var data = {
          'Edit':type,
          'LocationId': vm.sceneData.selected,
        }
        if(type != '3'){
          data.ShelvesName = vm.dioform.ShelveName
          data.DeviceId = vm.dioform.DeviceId
          data.VirtualShelf = ''
        }
        if(type != '1'){
          data.ShelvesId = vm.dioform.Id
        }
        const res = await bussinessApi.UpdateShelves(data)
        if(res.ErrCode == 0){
          showToast('更新成功！')
          vm.wareDio = false;//关闭弹窗
          vm.dioform.Id = ''
          vm.dioform.ShelvesName = ''
          vm.dioform.DeviceId = ''
          vm.WarehouseTree();//更新树形结构
          vm.ShelvesList(1);//更新货架列表
        }else{
          showToast(res.ErrMsg)
        }
      },

      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        if(vm.sceneData.Level == '-1'){
          vm.WareList(val)
        }else if(vm.sceneData.Level == '1'){
          vm.StoreHouseList(val)
        }else{
          vm.ShelvesList(val)
        }
      },
      
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CWarehouseManage{
  .mainBodyContent{
    display: flex;
    padding: 0;
    .leftTree{
      width: 280px;
      flex-shrink: 0;
      border-right: 1px solid #ddd;
    }
    .rightDiv{
      flex-grow: 1;
      padding:10px 24px 24px 10px;
    }
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }

  .addButton {
    margin-bottom: 24px;
  }
  .col6{
    color: #666;
  }
  .wareDio{
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .contDio{
      .selectedTree{
        font-weight: bold;
      }
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CWarehouseManage/CWarehouseManage.vue